export default __webpack_public_path__ + "static/media/iconImage.4114b50e.svg";